import { render } from "./RolesDialog.vue?vue&type=template&id=1dba2dc6&ts=true"
import script from "./RolesDialog.vue?vue&type=script&lang=ts"
export * from "./RolesDialog.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__